import React, { useState } from "react";
import { PageHeader, Section } from "@/components/PageHeader";
import { Card, CardContent } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import api from "@/lib/api";
import { FileSearch, Loader2 } from "lucide-react";

const Whois = () => {
  const [domain, setDomain] = useState("");
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  const lookup = async () => {
    if (!domain.includes(".")) {
      toast.error("Enter a valid domain");
      return;
    }
    setLoading(true);
    setData(null);
    try {
      const { data } = await api.get(`/whois/${encodeURIComponent(domain.trim().toLowerCase())}`);
      setData(data);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "WHOIS failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <PageHeader
        eyebrow="Lookup"
        title="WHOIS"
        description="Raw WHOIS lookup via TCP port 43. Queries IANA first, then the referral server."
      />
      <Section>
        <Card className="rounded-sm shadow-none border-[var(--border)]">
          <CardContent className="p-6">
            <div className="flex gap-2">
              <Input
                data-testid="whois-input"
                className="mono rounded-sm"
                value={domain}
                onChange={(e) => setDomain(e.target.value)}
                placeholder="example.com"
                onKeyDown={(e) => e.key === "Enter" && lookup()}
              />
              <Button
                data-testid="whois-btn"
                onClick={lookup}
                disabled={loading}
                className="brand-bg hover:brand-bg text-white rounded-sm min-w-[140px]"
              >
                {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <FileSearch className="w-4 h-4 mr-2" />}
                {loading ? "Querying..." : "Lookup"}
              </Button>
            </div>
          </CardContent>
        </Card>

        {data && (
          <div className="mt-6" data-testid="whois-result">
            <div className="text-[11px] uppercase tracking-[0.2em] text-[var(--text-secondary)] mb-2">
              {data.referral_server ? `via ${data.referral_server}` : "via whois.iana.org"}
            </div>
            <pre className="terminal p-4 rounded-sm overflow-auto text-xs whitespace-pre-wrap" style={{ maxHeight: 480 }}>
              {data.raw}
            </pre>
          </div>
        )}
      </Section>
    </div>
  );
};

export default Whois;
